/* ---------------------------------------------------------
* This file defines all production constants
------------------------------------------------------------ */

export const API_BASE_URL = 'https://subastasback.clubpremier.com/api/v1/auctions/public';
export const API_BASE_URL_PRIVATE = 'https://subastasback.clubpremier.com/api/v1/auctions/private';
export const API_BASE_URL_MEMBER = 'https://member.clubpremier.com/api/v1';
export const API_SOCKET = 'https://subastasnotify.clubpremier.com';
export const MEMBER_URL = 'https://member.clubpremier.com';
export const SUBASTAS_URL = 'https://subastas.clubpremier.com';
